import Color from 'color';

export const midnight = {
  dark: '#00002B',
  300: '#00004E',
  200: '#202D77',
  100: '#5E6EE9',
  80: '#8692EE',
  60: '#AEB6F4',
  40: '#CFD3F8',
  20: '#EAECFF',
};

export const blue = '#2D7CFF'; // hsl(217, 100%, 59%)
export const blueOnDark = Color('hsl(217, 100%, 68%)').hex(); // #5C9AFF

export const green = '#00CD73';
export const teal = '#42E1D9'; // hsl(177, 73%, 57%)
export const red = '#FF0049';

export const darkBackground = Color('hsl(240, 20%, 15%)').hex(); // #1F1F2E
